export default "__VITE_ASSET__61044dbf__"